<template>
    <div class="layout" :style="cssVars">
        <div class="content"
             v-if="viewsettings.loading"
             style="color:var(--bg-color); font-size:22px; font-weight:bold">
            {{ $t('loading') }}
        </div>

        <div class="content" v-if="!viewsettings.loading">
            <div v-if="viewsettings.pageindex == 0" class="section">
                <div class="item large" style="align-items: center; margin-top: 1rem;">
                    <img :src="logo_url" width="300" />
                </div>

                <div class="item large navbar"
                     style="flex-direction: row;"
                     v-if="!already_accepted && !already_rejected && !expired">
                    <div class="navigation-item">1. {{ $t('estimate') }}</div>
                    <div class="navigation-item disabled">2. {{ $t('personal_data') }}</div>
                    <div class="navigation-item disabled">3. {{ $t('summary') }}</div>
                </div>

                <div class="item large" style="display:flex; gap:10px; flex-direction:row;">
                    <div style="flex:1; display:flex" v-if="enable_rejection">
                        <button style="margin:0px" class="btn btn-reject" @click="go_to_rejection()">{{ $t('go_to_rejection') }}</button>
                    </div>

                    <div style="flex:1; display:flex">
                        <button  style="margin:0px" class="btn btn-accept"
                                @click="viewsettings.pageindex = 1"
                                v-if="!already_accepted && !already_rejected && !expired">
                            {{ $t('next') }}
                        </button>
                    </div>
                </div>

                <div class="item large" v-if="already_accepted" style="text-align:center">
                    <p>{{ $t('estimate_already_confirmed') }}</p>
                </div>

                <div class="item large" v-if="already_rejected" style="text-align:center">
                    <p>{{ $t('estimate_already_reject') }}</p>
                </div>

                <div class="item large" v-if="expired" style="text-align:center">
                    <p>{{ $t('estimate_expired') }}</p>
                </div>

                <div class="item large"
                     v-if="!already_accepted && !expired"
                     style="text-align:center">
                    <h3>
                        {{ $t('estimate_number') }} {{ estimateDisplayNumber }} {{ $t('of') }}
                        {{ estimateDate }} {{ $t('valid_until') }} {{ estimateValid }}
                    </h3>
                </div>

                <div class="item large" v-if="!expired">
                    <div id="pdfvuer" style="position:relative;">
                        <div id="buttons"
                             style="
                display: flex;
                position: absolute;
                right: 20px;
                top: 10px;
                z-index: 999999;
              ">
                            <a class="zoomel" @click="scale -= scale > 0.2 ? 0.1 : 0" style="margin-right:10px;">
                                <i class="fas fa-minus" />
                            </a>
                            <a class="zoomel" @click="scale += scale < 2 ? 0.1 : 0">
                                <i class="fas fa-plus" />
                            </a>
                        </div>
                        <div style="height:800px; overflow-y:scroll; max-width:90vw">
                            <pdf :src="pdfdata"
                                 v-for="i in numPages"
                                 :key="i"
                                 :id="i"
                                 :page="i"
                                 :scale.sync="scale"
                                 style="width:100%;margin:20px auto;">
                                <template slot="loading">
                                    {{ $t('loading') }}
                                </template>
                            </pdf>
                        </div>
                    </div>

                    <div style="text-align:center; padding: 20px;">
                        <a style="color: #ff6a00; font-size:20px; cursor:pointer; "
                           target="blank"
                           :href="estimate_url">
                            <i style="margin-right: 5px;" class="fas fa-download"></i>{{ $t('download_estimate') }}
                        </a>
                    </div>
                </div>

                <div class="item large"
                     style="display:flex;gap:10px;  flex-direction:row; margin-top:1rem;">
                    <div style="flex:1; display:flex" v-if="enable_rejection">
                        <button style="margin:0px" class="btn btn-reject" @click="go_to_rejection()">{{ $t('go_to_rejection') }}</button>
                    </div>

                    <div style="flex:1; display:flex">
                        <button  style="margin:0px" class="btn btn-accept"
                                @click="viewsettings.pageindex = 1"
                                v-if="!already_accepted && !already_rejected && !expired">
                            {{ $t('next') }}
                        </button>
                    </div>
                </div>
            </div>

            <ValidationObserver ref="formdata">
                <div v-if="viewsettings.pageindex == 1" class="section">
                    <div class="item large" style="align-items: center; margin-top: 1rem;">
                        <img :src="logo_url" width="300" />
                    </div>

                    <div class="item large navbar" style="flex-direction: row;">
                        <div @click="viewsettings.pageindex = 0" class="navigation-item disabled">
                            1. {{ $t('estimate') }}
                        </div>
                        <div class="navigation-item">2. {{ $t('personal_data') }}</div>
                        <div class="navigation-item disabled">3. {{ $t('summary') }}</div>
                    </div>


                    <div class="item large" style="display:flex;gap:10px; flex-direction:row;">
                        <div style="flex:1; display:flex">
                            <button style="margin:0px" class="btn" @click="viewsettings.pageindex = 0">{{ $t('back') }}</button>
                        </div>

                        <div style="flex:1; display:flex" v-if="enable_rejection">
                            <button style="margin:0px" class="btn btn-reject" @click="go_to_rejection()">{{ $t('go_to_rejection') }}</button>
                        </div>

                        <div style="flex:1; display:flex">
                            <button style="margin:0px" class="btn btn-accept" @click="go_to_summary()">{{ $t('go_to_summary') }}</button>
                        </div>
                    </div>

                    <div class="item large">
                        <label>{{ $t('billing_method') }}</label>
                        <select v-model="invoiceholder.mode" :placeholder="$t('billing_method')">
                            <option :value="0">{{ $t('company') }}</option>
                            <option :value="10">{{ $t('individual') }}</option>
                        </select>
                    </div>

                    <ValidationProvider vid="invoice_companyname" v-show="false">
                        <input type="hidden" v-model="invoice_companyname_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_companyname,true"
                                        class="item large"
                                        v-slot="{ errors }"
                                        v-if="invoiceholder.mode == 0">
                        <label>
                            {{ $t('company_name') }}
                            <span class="required_field" v-if="invoice_companyname_required">*</span>
                        </label>
                        <input type="text"
                               v-model="invoiceholder.companyname"
                               :placeholder="$t('company_name')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_firstname" v-show="false">
                        <input type="hidden" v-model="invoice_firstname_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_firstname,true"
                                        class="item"
                                        v-slot="{ errors }"
                                        v-if="invoiceholder.mode == 10">
                        <label>
                            {{ $t('first_name') }}
                            <span class="required_field" v-if="invoice_firstname_required">*</span>
                        </label>
                        <input type="text"
                               v-model="invoiceholder.firstname"
                               :placeholder="$t('first_name')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_lastname" v-show="false">
                        <input type="hidden" v-model="invoice_lastname_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_lastname,true"
                                        class="item"
                                        v-slot="{ errors }"
                                        v-if="invoiceholder.mode == 10">
                        <label>
                            {{ $t('last_name') }}
                            <span class="required_field" v-if="invoice_lastname_required">*</span>
                        </label>
                        <input type="text"
                               v-model="invoiceholder.lastname"
                               :placeholder="$t('last_name')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_address" v-show="false">
                        <input type="hidden" v-model="invoice_address_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_address,true"
                                        class="item large"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('address') }}
                            <span class="required_field" v-if="invoice_address_required">*</span>
                        </label>
                        <input type="text"
                               v-model="invoiceholder.address"
                               :placeholder="$t('address')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_city" v-show="false">
                        <input type="hidden" v-model="invoice_city_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_city,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('city') }}
                            <span class="required_field" v-if="invoice_city_required">*</span>
                        </label>
                        <input type="text" v-model="invoiceholder.city" :placeholder="$t('city')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_province" v-show="false">
                        <input type="hidden" v-model="invoice_province_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_province,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('province') }}
                            <span class="required_field" v-if="invoice_province_required">*</span>
                        </label>
                        <input type="text"
                               v-mask="'AA'"
                               v-model="invoiceholder.province"
                               :placeholder="$t('province')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_postalcode" v-show="false">
                        <input type="hidden" v-model="invoice_postalcode_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_postalcode,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('postal_code') }}
                            <span class="required_field" v-if="invoice_postalcode_required">*</span>
                        </label>
                        <input v-mask="'#####'"
                               type="text"
                               v-model="invoiceholder.postalcode"
                               :placeholder="$t('postal_code')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_country" v-show="false">
                        <input type="hidden" v-model="invoice_country_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_country,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('country') }}
                            <span class="required_field" v-if="invoice_country_required">*</span>
                        </label>

                        <CountrySelect v-model="invoiceholder.country" :placeholder="$t('country')" />

                        <div>{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_taxcode" v-show="false">
                        <input type="hidden" v-model="invoice_taxcode_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_taxcode,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('tax_code') }}
                            <span class="required_field" v-if="invoice_taxcode_required">*</span>
                        </label>
                        <input type="text"
                               v-model="invoiceholder.taxcode"
                               :placeholder="$t('tax_code')" />

                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_vatcode" v-show="false">
                        <input type="hidden" v-model="invoice_vatcode_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_vatcode,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('vat_number') }}
                            <span class="required_field" v-if="invoice_vatcode_required">*</span>
                        </label>
                        <input type="text"
                               v-model="invoiceholder.vatcode"
                               :placeholder="$t('vat_number')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_iban" v-show="false">
                        <input type="hidden" v-model="invoice_iban_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_iban,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('iban') }}
                            <span class="required_field" v-if="invoice_iban_required">*</span>
                        </label>
                        <input type="text" v-model="invoiceholder.iban" :placeholder="$t('iban')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_destinationcode" v-show="false">
                        <input type="hidden" v-model="invoice_destinationcode_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_destinationcode,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('electronic_invoice_code') }}
                            <span class="required_field" v-if="invoice_destinationcode_required">*</span>
                        </label>
                        <input type="text"
                               v-model="invoiceholder.electronicinvoicecode"
                               :placeholder="$t('electronic_invoice_code')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="invoice_pec" v-show="false">
                        <input type="hidden" v-model="invoice_pec_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:invoice_pec,true"
                                        class="item"
                                        v-slot="{ errors }">
                        <label>
                            {{ $t('pec') }}
                            <span class="required_field" v-if="invoice_pec_required">*</span>
                        </label>
                        <input type="text" v-model="invoiceholder.pec" :placeholder="$t('pec')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <div class="item large">
                        <label>{{ $t('different_shipping_address') }}</label>
                        <input type="checkbox"
                               v-model="deliveryholder.send_to_different_address" />
                    </div>

                    <ValidationProvider vid="delivery_companyname" v-show="false">
                        <input type="hidden" v-model="delivery_companyname_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:delivery_companyname,true"
                                        class="item large"
                                        v-slot="{ errors }"
                                        v-if="deliveryholder.send_to_different_address">
                        <label>
                            {{ $t('ship_to') }}
                            <span class="required_field" v-if="delivery_companyname_required">*</span>
                        </label>
                        <input type="text"
                               v-model="deliveryholder.companyname"
                               :placeholder="$t('ship_to')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="delivery_address" v-show="false">
                        <input type="hidden" v-model="delivery_address_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:delivery_address,true"
                                        class="item large"
                                        v-slot="{ errors }"
                                        v-if="deliveryholder.send_to_different_address">
                        <label>
                            {{ $t('shipping_address') }}
                            <span class="required_field" v-if="delivery_address_required">*</span>
                        </label>
                        <input type="text"
                               v-model="deliveryholder.address"
                               :placeholder="$t('shipping_address')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="delivery_city" v-show="false">
                        <input type="hidden" v-model="delivery_city_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:delivery_city,true"
                                        class="item"
                                        v-slot="{ errors }"
                                        v-if="deliveryholder.send_to_different_address">
                        <label>
                            {{ $t('shipping_city') }}
                            <span class="required_field" v-if="delivery_city_required">*</span>
                        </label>
                        <input type="text"
                               v-model="deliveryholder.city"
                               :placeholder="$t('shipping_city')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="delivery_province" v-show="false">
                        <input type="hidden" v-model="delivery_province_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:delivery_province,true"
                                        class="item"
                                        v-slot="{ errors }"
                                        v-if="deliveryholder.send_to_different_address">
                        <label>
                            {{ $t('shipping_province') }}
                            <span class="required_field" v-if="delivery_province_required">*</span>
                        </label>
                        <input type="text"
                               v-mask="'AA'"
                               v-model="deliveryholder.province"
                               :placeholder="$t('shipping_province')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="delivery_postalcode" v-show="false">
                        <input type="hidden" v-model="delivery_postalcode_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:delivery_postalcode,true"
                                        class="item"
                                        v-slot="{ errors }"
                                        v-if="deliveryholder.send_to_different_address">
                        <label>
                            {{ $t('shipping_postal_code') }}
                            <span class="required_field" v-if="delivery_postalcode_required">*</span>
                        </label>
                        <input v-mask="'#####'"
                               type="text"
                               v-model="deliveryholder.postalcode"
                               :placeholder="$t('shipping_postal_code')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider vid="delivery_country" v-show="false">
                        <input type="hidden" v-model="delivery_country_required" />
                    </ValidationProvider>
                    <ValidationProvider tag="div"
                                        rules="required_if:delivery_country,true"
                                        class="item"
                                        v-slot="{ errors }"
                                        v-if="deliveryholder.send_to_different_address">
                        <label>
                            {{ $t('shipping_country') }}
                            <span class="required_field" v-if="delivery_country_required">*</span>
                        </label>
                        <CountrySelect v-model="deliveryholder.country"
                                       :placeholder="$t('shipping_country')" />
                        <div>{{ errors[0] }}</div>
                    </ValidationProvider>

                    <div class="item large" style="display:flex;gap:10px;  flex-direction:row;">
                        <div style="flex:1; display:flex">
                            <button style="margin:0px" class="btn" @click="viewsettings.pageindex = 0">{{ $t('back') }}</button>
                        </div>

                        <div style="flex:1; display:flex" v-if="enable_rejection">
                            <button style="margin:0px" class="btn btn-reject" @click="go_to_rejection()">{{ $t('go_to_rejection') }}</button>
                        </div>

                        <div style="flex:1; display:flex">
                            <button style="margin:0px" class="btn btn-accept" @click="go_to_summary()">{{ $t('go_to_summary') }}</button>
                        </div>
                    </div>
                </div>
            </ValidationObserver>

            <ValidationObserver ref="summary">
                <div v-if="viewsettings.pageindex == 2" class="section">
                    <div class="item large" style="align-items: center; margin-top: 1rem;">
                        <img :src="logo_url" width="300" />
                    </div>
                    <div class="item large navbar" style="flex-direction: row;">
                        <div class="navigation-item disabled">1. {{ $t('estimate') }}</div>
                        <div class="navigation-item disabled">2. {{ $t('personal_data') }}</div>
                        <div class="navigation-item">3. {{ $t('summary') }}</div>
                    </div>

                    <div class="item large" style="text-align: center;" v-if="!hidetotal">
                        <p>{{ estimateName }} n. {{ estimateNumber }} del {{ estimateDate }}</p>
                        <p>
                            {{ $t('you_are_about_to_confirm') }}
                            <span style="font-weight: bold;">{{ estimateTotal }}</span>
                            ({{ $t('vat_included') }} {{ estimateVatTotal }})
                        </p>
                        <p>
                            {{ $t('payment_method_is') }}
                            <span style="font-weight: bold;">{{ payment_method }}</span>
                        </p>
                    </div>

                    <ValidationProvider tag="div" rules="required" class="item" v-slot="{ errors }">
                        <label>
                            {{ $t('signer_first_name') }}
                            <span class="required_field">*</span>
                        </label>
                        <input type="text"
                               v-model="acceptor_firstname"
                               :placeholder="$t('signer_first_name')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider tag="div" rules="required" class="item" v-slot="{ errors }">
                        <label>
                            {{ $t('signer_last_name') }}
                            <span class="required_field">*</span>
                        </label>
                        <input type="text"
                               v-model="acceptor_lastname"
                               :placeholder="$t('signer_last_name')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <div class="item large" v-if="!otp_disabled">
                        <label v-if="!verified">{{ $t('verification_code') }}</label>
                        <div style="display:flex" v-if="!verified">
                            <input type="text"
                                   v-model="pin"
                                   @input="checkpin"
                                   :placeholder="$t('enter_received_code')" />
                        </div>
                        <div style="color:red;margin-top:5px;"
                             v-if="!verified && pinerror != ''">{{ pinerror }}</div>
                        <div v-if="verified" class="verified-pin">{{ $t('code_verified') }}</div>
                        <div v-if="!verified">
                            <a @click="resendonetimepin"
                               style="margin-top:1rem; font-size: 14px;color: var(#ff0000);margin-top: 5px; float:right; cursor:pointer;text-decoration:underline;">{{ $t('code_not_received') }}</a>
                        </div>
                    </div>

                    <div class="item large" style="display:flex; gap:10px; flex-direction:row;">
                        <div style="flex:1; display:flex">
                            <button style="margin:0px;" class="btn" @click="viewsettings.pageindex = 1">{{ $t('back') }}</button>
                        </div>
                        <div style="flex:1; display:flex">
                            <button style="margin:0px;" class="btn btn-accept " @click="end" :class="{'btn_disabled' : !verified}">
                                {{ $t('confirm') }}
                                <template v-if="paymentlink != null && paymentlink != '' && enabled_paymentlink">
                                    {{ $t('and_go_to_payment') }}
                                </template>
                                <template v-else>
                                    {{ $t('confirm_estimate') }}
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </ValidationObserver>

            <ValidationObserver ref="summary">
                <div v-if="viewsettings.pageindex == 3" class="section">
                    <div class="item large" style="align-items: center; margin-top: 1rem;">
                        <img :src="logo_url" width="300" />
                    </div>

                    <div class="item large navbar" style="flex-direction: row;">
                        <div class="navigation-item disabled">1. {{ $t('estimate') }}</div>
                        <div class="navigation-item disabled">2. {{ $t('personal_data') }}</div>
                        <div class="navigation-item">3. {{ $t('summary') }}</div>
                    </div>

                    <div class="item large" style="text-align: center;" v-if="!hidetotal">
                        <p>{{ estimateName }} n. {{ estimateNumber }} del {{ estimateDate }}</p>
                        <p>
                            {{ $t('you_are_about_to_reject') }}
                            <span style="font-weight: bold;">{{ estimateTotal }}</span>
                            ({{ $t('vat_included') }} {{ estimateVatTotal }})
                        </p>
                    </div>

                    <div class="item large" v-if="rejectionReasons && rejectionReasons.length > 0">
                        <label>{{ $t('rejection_reason') }}</label>
                        <select v-model="selectedRejectionReason">
                            <option value="">{{ $t('select_reason') }}</option>
                            <option v-for="reason in rejectionReasons" :key="reason.id" :value="reason.id">
                                {{ reason.label }}
                            </option>
                        </select>
                        
                        <label style="margin-top: 1rem;">{{ $t('rejection_notes') }}</label>
                        <textarea 
                            v-model="RejectEstimateNotes" 
                            rows="4" 
                            style="resize: vertical;
    padding: 16px !important;
    border: none;
    color: #6b6b6b;
    background-color: #eee;
    margin-top: .5rem;
    -webkit-box-flex: 1;
    flex-grow: 1;
    border-radius: 5px;
"
                           :placeholder="$t('rejection_notes_placeholder')">
                        </textarea>
                    </div>

                    <ValidationProvider tag="div" rules="required" class="item" v-slot="{ errors }">
                        <label>
                            {{ $t('signer_first_name') }}
                            <span class="required_field">*</span>
                        </label>
                        <input type="text"
                               v-model="acceptor_firstname"
                               :placeholder="$t('signer_first_name')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <ValidationProvider tag="div" rules="required" class="item" v-slot="{ errors }">
                        <label>
                            {{ $t('signer_last_name') }}
                            <span class="required_field">*</span>
                        </label>
                        <input type="text"
                               v-model="acceptor_lastname"
                               :placeholder="$t('signer_last_name')" />
                        <div class="error_description">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <div class="item large" v-if="!otp_disabled">
                        <label v-if="!verified">{{ $t('verification_code') }}</label>
                        <div style="display:flex" v-if="!verified">
                            <input type="text"
                                   v-model="pin"
                                   @input="checkpin"
                                   :placeholder="$t('enter_received_code')" />
                        </div>
                        <div style="color:red;margin-top:5px;"
                             v-if="!verified && pinerror != ''">{{ pinerror }}</div>
                        <div v-if="verified" class="verified-pin">{{ $t('code_verified') }}</div>
                        <div v-if="!verified">
                            <a @click="resendonetimepin"
                               style="margin-top:1rem; font-size: 14px;color: var(#ff0000);margin-top: 5px; float:right; cursor:pointer;text-decoration:underline;">{{ $t('code_not_received') }}</a>
                        </div>
                    </div>

                    <div class="item large" style="display:flex; gap:10px; flex-direction:row; gap:10px;">
                        <div style="flex:1; display:flex">
                            <button style="margin:0px" class="btn" @click="viewsettings.pageindex = 1">{{ $t('back') }}</button>
                        </div>
                        <div style="flex:1; display:flex">
                            <button style="margin:0px"  class="btn btn-reject btn-reject" @click="reject" :class="{'btn_disabled' : !verified}">
                                {{ $t('reject') }}
                                {{ $t('reject_estimate') }}
                            </button>
                        </div>
                    </div>
                </div>
            </ValidationObserver>

            <div v-if="viewsettings.pageindex == 4" class="section">
                <div class="item large" style="align-items: center; margin-top: 1rem;">
                    <img :src="logo_url" width="300" />
                </div>
                <div class="item large" style="text-align: center; margin-top: 2rem; margin-bottom: 2rem;">
                    <i class="fas fa-times-circle" style="font-size: 60px; color: #dc3545; margin-bottom: 1rem;"></i>
                    <h2 style="color: #dc3545;">{{ $t('estimate_rejected_title') }}</h2>
                    <p style="font-size: 18px;">
                        {{ $t('estimate_rejected_message') }}
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import pdfvuer from 'pdfvuer'
    export default {
        components: {
            pdf: pdfvuer
        },
        name: "Estimate",
        data: () => {
            return {
                page: 1,
                numPages: 0,
                pdfdata: undefined,
                requiredfields: [],
                errors: [],
                scale: 'page-width',
                logo_url: "https://app.takeoffcrm.com/Content/Images/Images_New/logo-takeoff.jpg",
                estimate_url: "",
                hidetotal: false,
                viewsettings: {
                    loading: true,
                    pageindex: 0,
                    logourl: "",
                },
                already_accepted: false,
                already_rejected: false,
                estimatecode: null,
                estimateName: "",                
                expired: false,
                estimateTotal: "",
                estimateNumber: "",
                estimateFullNumber: "",
                estimateDisplayNumber: "",
                estimateDate: "",
                estimateVatTotal: "",
                payment_method: "",
                pin: "",
                verified: false,
                pinerror: '',
                deliveryholder: {
                    send_to_different_address: true,
                    companyname: "",
                    address: "",
                    city: "",
                    province: "",
                    postalcode: "",
                    country: "",
                },
                invoiceholder: {
                    mode: 0,
                    companyname: "",
                    firstname: "",
                    lastname: "",
                    address: "",
                    city: "",
                    province: "",
                    postalcode: "",
                    country: "",
                    taxcode: "",
                    vatccode: "",
                    electronicinvoicecode: "",
                    pec: ""
                },
                acceptor_firstname: "",
                acceptor_lastname: "",
                redirecturl: "",

                enable_rejection: false,
                
                rejectionReasons: [],
                selectedRejectionReason: "",
                RejectEstimateNotes: "", 

                otp_disabled: false,
                enabled_paymentlink: false,
                paymentlink: ""
            };
        },
        computed: {
            formattedZoom() {
                return Number.parseInt(this.scale * 100);
            },
            cssVars() {
                return {
                    "--bg-color":
                        this.viewsettings.primarycolor != null &&
                            this.viewsettings.primarycolor != ""
                            ? this.viewsettings.primarycolor
                            : "#ff6a00"
                };
            },
            invoice_companyname_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_CompanyName";
                    }) != null
                );
            },
            invoice_firstname_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_FirstName";
                    }) != null
                );
            },
            invoice_lastname_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_LastName";
                    }) != null
                );
            },
            invoice_address_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_Address";
                    }) != null
                );
            },
            invoice_city_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_City";
                    }) != null
                );
            },
            invoice_postalcode_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_PostalCode";
                    }) != null
                );
            },
            invoice_province_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_Province";
                    }) != null
                );
            },
            invoice_country_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_Country";
                    }) != null
                );
            },
            invoice_vatcode_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_VatCode";
                    }) != null && this.invoiceholder.mode == 0
                );
            },
            invoice_iban_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_Iban";
                    }) != null
                );
            },
            invoice_taxcode_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_TaxCode";
                    }) != null
                );
            },
            invoice_destinationcode_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_DestinationCode";
                    }) != null && this.invoiceholder.mode == 0
                );
            },
            invoice_pec_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "InvoiceHolder_Pec";
                    }) != null
                );
            },
            delivery_companyname_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "DeliveryHolder_CompanyName";
                    }) != null
                );
            },
            delivery_address_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "DeliveryHolder_Address";
                    }) != null
                );
            },
            delivery_city_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "DeliveryHolder_City";
                    }) != null
                );
            },
            delivery_postalcode_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "DeliveryHolder_PostalCode";
                    }) != null
                );
            },
            delivery_province_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "DeliveryHolder_Province";
                    }) != null
                );
            },
            delivery_country_required() {
                return (
                    this._.find(this.requiredfields, o => {
                        return o == "DeliveryHolder_Country";
                    }) != null
                );
            },
        },
        watch: {
            show: function (s) {
                if (s) {
                    this.getPdf();
                }
            },
            page: function (p) {
                if (window.pageYOffset <= this.findPos(document.getElementById(p)) || (document.getElementById(p + 1) && window.pageYOffset >= this.findPos(document.getElementById(p + 1)))) {
                    document.getElementById(p).scrollIntoView();
                }
            }
        },
        methods: {
            getPdf() {
                var self = this;
                self.pdfdata = pdfvuer.createLoadingTask(this.estimate_url);
                self.pdfdata.then((pdf) => {
                    self.numPages = pdf.numPages;
                });
            },
            async resendonetimepin() {
                this.pin = "";
                this.pinerror = "";
                this.verified = false;
                await this.axios({
                    method: "post",
                    url: "/OneTimePin/" + this.estimatecode,
                });
            },
            async checkpin() {
                this.pinerror = "";

                if (this.pin == "") {
                    this.pinerror = this.$t('wrong_code');
                    return;
                }

                try {
                    await this.axios({
                        method: "get",
                        url: "/OneTimePin/" + this.estimatecode + "/" + this.pin + "/verify",
                    });
                    this.verified = true;
                } catch {
                    this.pinerror = this.$t('wrong_code');
                }
            },
            async go_to_summary() {
                var valid = await this.$refs.formdata.validate();
                if (!valid) {
                    alert(this.$t('fill_required_fields'));
                    return;
                }
                if (!this.otp_disabled) {
                    await this.axios({
                        method: "post",
                        url: "/OneTimePin/" + this.estimatecode,
                    });
                } else {
                    this.verified = true;
                }
                this.viewsettings.pageindex = 2;
            },
            async go_to_rejection() {
                if (!this.otp_disabled) {
                    await this.axios({
                        method: "post",
                        url: "/OneTimePin/" + this.estimatecode + "/reject",
                    });
                } else {
                    this.verified = true;
                }
                this.viewsettings.pageindex = 3;
            },
            async end() {
                if (!this.verified) {
                    return;
                }
                var valid = await this.$refs.summary.validate();
                if (!valid) {
                    alert(this.$t('fill_required_fields'));
                    return;
                }
                this.viewsettings.loading = true;
                await this.axios({
                    method: "put",
                    url: "/Estimates/" + this.estimatecode,
                    data: {
                        deliveryholder: this.deliveryholder,
                        invoiceholder: this.invoiceholder,
                        acceptor_firstname: this.acceptor_firstname,
                        acceptor_lastname: this.acceptor_lastname,
                    },
                });
                this.viewsettings.loading = false;

                if (
                    this.paymentlink != null &&
                    this.paymentlink != "" &&
                    this.enabled_paymentlink
                ) {
                    window.location = this.paymentlink;
                } else {
                    this.$router.push({
                        name: "Success",
                        params: { code: this.estimatecode },
                    });
                }
            },
            async reject() {
                if (!this.verified) {
                    return;
                }
                var valid = await this.$refs.summary.validate();
                if (!valid) {
                    alert(this.$t('fill_required_fields'));
                    return;
                }
                this.viewsettings.loading = true;
                await this.axios({
                    method: "put",
                    url: "/Estimates/" + this.estimatecode + "/reject",
                    data: {
                        deliveryholder: this.deliveryholder,
                        invoiceholder: this.invoiceholder,
                        acceptor_firstname: this.acceptor_firstname,
                        acceptor_lastname: this.acceptor_lastname,
                        EstimateClosingReasonId: this.selectedRejectionReason !== "" ? parseInt(this.selectedRejectionReason) : null,
                        RejectEstimateNotes: this.RejectEstimateNotes 
                    },
                });
                this.viewsettings.loading = false;

                this.viewsettings.pageindex = 4;
            },
        },
        async mounted() {
       
            this.estimatecode = this.$route.params.code;
            if (this.estimatecode == undefined || this.estimatecode == null) {
                alert(this.$t('page_load_error'));
                return;
            }
            const res = await this.axios({
                method: "get",
                url: "/Estimates/" + this.estimatecode,
            });
            var data = res.data.EstimateData;
            this.estimate_url = "/estimates/download/" + this.estimatecode;
            this.getPdf();
            if (data.Logo != null) {
                this.logo_url = data.Logo;
            }
            this.already_accepted = data.already_accepted;
            this.already_rejected = data.already_rejected;
            this.invoiceholder = data.invoiceholder;
            this.deliveryholder = data.deliveryholder;
            this.estimateName = data.estimateName;
            this.expired = data.expired;
            this.estimateNumber = data.estimateNumber;
            this.estimateFullNumber = data.estimateFullNumber;
            this.estimateDate = data.estimateDate;
            this.estimateValid = data.estimateValid;
            this.estimateTotal = data.estimateTotal;
            this.estimateVatTotal = data.estimateVatTotal;
            this.payment_method = data.payment_method;
            this.requiredfields = data.RequiredFields;
            this.viewsettings.loading = false;
            this.hidetotal = data.hideTotal;

            this.enable_rejection = res.data.EnableRejection;
     
            this.estimateDisplayNumber = data.estimateFullNumber === null || data.estimateFullNumber === undefined || data.estimateFullNumber.length == 0 ? data.estimateNumber : data.estimateFullNumber;

            
            if (res.data.RejectionReasons && res.data.RejectionReasons.length > 0) {
                this.rejectionReasons = res.data.RejectionReasons.map(item => {
                    const key = Object.keys(item)[0];
                    return {
                        id: key,
                        label: item[key]
                    };
                });
            }

            this.otp_disabled = data.otp_disabled;
            this.enabled_paymentlink = data.enabled_paymentlink;
            this.paymentlink = data.paymentlink;


            const urlParams = new URLSearchParams(window.location.search);
            const lang = urlParams.get('lang');
            if (lang != null && lang == "es" && this.invoiceholder.country == null) {
                this.invoiceholder.country = "ES";
                this.deliveryholder.country = "ES";
            } else {
                this.invoiceholder.country = "IT";
                this.deliveryholder.country = "IT";
            }

        },
    };
</script>

<style>

    .btn-accept {
        background-color: #28a745 !important;
    }
    .btn-accept:hover {
        background-color: #218838 !important;
    }

    .btn-reject {
        background-color: #dc3545 !important;
    }
    .btn-reject:hover {
        background-color: #c82333 !important;
    }

    .btn_disabled {
        background: #f8d1b5 !important;
        cursor: not-allowed !important;
    }
    .btn_disabled:hover {
        transform: scale(1) !important;
        background: #f8d1b5 !important;
    }

    .layout {
        min-height: 100vh;
        background-color: #ffa667;
        display: grid;
        grid-template-rows: 100px auto auto;
        grid-template-columns: auto 0.8fr auto;
        grid-template-areas:
            ". . ."
            ". contents ."
            ". . .";
        background: #ffcca8;
    }

    @media (max-width: 992px) {
        .section {
            border-radius: 0px !important;
        }
    }

    @media screen and (max-width: 992px) {
        .layout {
            min-height: 100vh;
            background-color: #ffbe90;
            display: grid;
            grid-template-rows: auto;
            grid-template-columns: 1fr;
            grid-template-areas: "contents";
        }
    }

    .verified-pin {
        text-align: center;
        border: 3px solid var(--bg-color);
        color: var(--bg-color);
        padding: 10px;
        font-weight: bold;
        border-radius: 10px;
    }

    .content {
        grid-area: contents;
        display: flex;
        justify-content: center;
    }

    .section {
        flex-wrap: wrap;
        display: flex;
        background-color: #fff;
        max-width: 800px;
        align-content: baseline;
        border-radius: 10px;
        box-shadow: 0px 0px 15px #b4784e;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: fit-content;
        margin-bottom: 4rem;
    }

    .item {
        min-width: 300px;
        width: 300px;
        padding: 1rem;
        flex-grow: 1;
        display: flex;
        flex-flow: column;
    }

    .item.large {
        width: 100%;
    }

    .item input,
    .item select,
    .datetimeelement {
        padding: 16px !important;
        border: none;
        border-radius: 0;
        color: #6b6b6b;
        background-color: #eee;
        margin-top: 0.5rem;
        flex-grow: 1;
        border-radius: 5px;
    }

    .displayflex > div:first-child {
        display: flex;
        flex-grow: 1;
    }

    .item .readonly {
        padding: 16px !important;
        border: none;
        border-radius: 0;
        color: #6b6b6b;
        background-color: #eee;
        margin-top: 0.5rem;
        font-size: 13.33px;
        height: 16.1px;
    }

    .btn {
        background-color: var(--bg-color);
        border: none;
        padding: 1rem;
        color: #fff;
        flex: 1;
        margin: 0;
        cursor: pointer;
        border-radius: 10px;
        transition: all 0.3s;
    }

    .btn:hover {
        transform: scale(1.03);
    }

    .btn-small {
        background-color: var(--bg-color);
        border: none;
        padding: 1rem;
        color: #fff;
    }

    .required_field {
        color: red;
        font-size: 24px;
        font-weight: bold;
    }

    .error_description {
        color: red;
        font-weight: bold;
        margin-top: 0.5rem;
    }

    .check_container {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        cursor: pointer;
    }

    .check {
        width: 15px;
        height: 15px;
        border: 2px solid var(--bg-color);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
    }

    .check .dot {
        width: 10px;
        height: 10px;
        background-color: var(--bg-color);
        border-radius: 50%;
        display: inline-block;
        opacity: 0;
    }

    .check.checked .dot {
        width: 10px;
        height: 10px;
        background-color: var(--bg-color);
        border-radius: 50%;
        display: inline-block;
        opacity: 1;
    }

    .navigation-item {
        padding: 1rem;
        flex-grow: 1;
        background-color: var(--bg-color);
        color: #fff;
        text-align: center;
        width: 25%;
    }

    .navigation-item.disabled {
        color: rgb(125, 125, 125) !important;
        background-color: rgb(238, 238, 238);
    }

    .navbar {
        flex-direction: row;
        border-radius: 10px;
        margin: 1rem;
        margin-top: 2rem;
        padding: 0px;
        overflow: hidden;
    }

    .zoomel {
        background-color: #efefef;
        color: #fff;
        width: 30px;
        height: 30px;
        color: #8e8e8e;
        box-shadow: 0px 0px 3px #8f8f8f;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
    }
</style>
